import api from "@/api/api.js";
import { FISCAL_DOCUMENTS } from "@/utils/fiscalDocuments.js";

/**
 * Descarga un documento fiscal concreto, sea la constancia o la opinión 32/D.
 * El tipo decide la ruta; el resto es igual para todos.
 */
const FiscalDocumentDownload = ({
  companyId,
  documentId,
  type = "fiscalCertificate",
  fileName,
  label,
  disabled = false,
  className = "btn btn-primary",
}) => {
  const { route, fileName: fallbackName } = FISCAL_DOCUMENTS[type];

  const handleDownload = async () => {
    try {
      const response = await api.get(
        `/companies/${companyId}/${route}/${documentId}/download`,
        { responseType: "blob" },
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName || fallbackName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando el archivo:", error);
    }
  };

  return (
    <button className={className} onClick={handleDownload} disabled={disabled}>
      <i className="bi bi-download me-1" />
      {label || fileName || fallbackName}
    </button>
  );
};

export default FiscalDocumentDownload;
